import React, { useEffect, useState } from "react";
import ContainerSlider from "./ContainerSlider";
import ContainerServices from "../../container/containerServices";
import { CommonUtilities } from "../../../commonUtils";
import PeriodSelectionForm from "../../PeriodSelection/periodSelectionForm";
import { format } from "date-fns";
import { Filter } from "../../../filter";
import directoryServices from "../directoryServices";
import Pagination from "../../Header/Pagination";
import cachingMechanisum from "../../Common/cachingMechanisum";

export default function DirectoryAnalytic(param: any) {

    let [totalRows, setTotalRows] = useState(0);
    let [hideGraph, sethideGraph] = useState(true);
    let [reportingTo, setreportingTo] = useState("");
    let [execHeader, setexecHeader] = useState<any>([]);
    let [headerType, setHeaderType] = useState<any>([]);
    let [reportingFrom, setreportingFrom] = useState("");
    let [transaction_Ref, setTransaction_Ref] = useState("");
    let [headerMaping, setHeaderMaping] = useState<any>([]);
    let [activeAllTime, setactiveAllTime] = useState(false);
    let [periodSelection, setperiodSelection] = useState(false);
    let [dialogueOpenView, setdialogueOpenView] = useState(false);
    let [projectAnalysisSummary, setprojectAnalysisSummary] = useState<any>([]);
    let [activePerformanceTab, setactivePerformanceTab] = useState("Performance");
    let [financialPerformanceList, setfinancialPerformanceList] = useState<any>([]);

    var payload = {
        type: "Performance",
        level: 2,
        pageNumber: 1,
        pageSize: 10,
        directoryCode: "",
        kontactCode: "",
        companyName: "",
        assetCode: "",
        Workspace: param?.DAOpen === "Creator" || param?.DAOpen === "Imprint" || param?.DAOpen === "Asset" ? "d" : "All",
        periodTo: reportingTo,
        periodFrom: reportingFrom,
        transaction_Ref: transaction_Ref,
        SubProvider: "",
        activeAllTime: 0
    }

    var payBuildload = { type: "BuildWorkSpace", directoryCode: "", kontactCode: "", companyName: "", assetCode: "", Workspace: "d", SubProvider: "" }


    let [periodSelected, SetperiodSelected] = useState<any>([]);
    let [criterias, setCriterias] = useState<any>([]);
    let [containerType, setcontainerType] = useState<any>([]);
    let [clientDetailList, setclientDetailList] = useState<any>([]);
    let [globalSearchList, setglobalSearchList] = useState<any>([]);

    var globalType = 'ContractRoyaltyDetail';

    useEffect(() => {
        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        clientDetailList = cachingMechanisum.getCachingStorage("ClientDetails");
        setclientDetailList(clientDetailList)
        //console.log(periodListCache)
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }

        //console.log(param)
        UpdatePayload();

        //console.log(reportingFrom);
        var year = String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)).substring(0, 4);
        //console.log(year);

        reportingFrom = reportingFrom !== '' ? reportingFrom : year + '0101';
        reportingTo = reportingTo !== '' ? reportingTo : year + '1231';
        setreportingFrom(reportingFrom);
        setreportingTo(reportingTo);

        if (param && param.summaryPayload) {

            if (param?.summaryPayload?.periodFrom) {
                reportingFrom = param?.summaryPayload?.periodFrom;
                setreportingFrom(reportingFrom);
            }

            if (param?.summaryPayload?.periodFrom) {
                reportingTo = param?.summaryPayload?.periodTo;
                setreportingTo(reportingTo);
            }

            if (param?.summaryPayload?.transaction_Ref) {
                transaction_Ref = param?.summaryPayload?.transaction_Ref
                setTransaction_Ref(transaction_Ref);
                payload.transaction_Ref = param?.summaryPayload?.transaction_Ref;
            }

            if (param?.summaryPayload?.criteriaList) {
                criterias = param?.summaryPayload?.criteriaList
                setCriterias(criterias);
                setcontainerType([]);

                for (var $i = 0; $i < criterias.length; $i++) {

                    var temp = containerType?.filter((containerTypeItem: any) => containerTypeItem === criterias[$i].containerType);
                    if (temp.length === 0) {
                        containerType.push(criterias[$i].containerType);
                    }
                }
                setcontainerType(containerType);
            }
        }

        containerSearch(2);
        containerSearch(1);

        if (activePerformanceTab === "Financial") {
            globalType = 'ContractRoyaltyDetail'
        }

        if (activePerformanceTab === "Performance") {
            globalType = 'ContractAuditDetail'
        }

        globalSearchList = []
        directoryServices.globalSearchList(globalType).then((data) => {
            globalSearchList = data;
            setglobalSearchList(globalSearchList)
        })


    }, [])

    const onChangeClose = (e: any) => {
        //console.log(e)
        //console.log(e?.containerSet)
        if (e && e.action === 'search') {
            setcontainerType([])

            transaction_Ref = e.tranRef
            setTransaction_Ref(transaction_Ref)

            criterias = e?.containerSet
            setCriterias(criterias)

            for (var $i = 0; $i < e?.containerSet.length; $i++) {

                var temp = containerType?.filter((containerTypeItem: any) => containerTypeItem === e?.containerSet[$i].containerType);
                //console.log(temp)
                //console.log(temp.length)
                if (temp.length === 0) {
                    containerType.push(e?.containerSet[$i].containerType);
                }
            }

            setcontainerType(containerType)
            //console.log(containerType)
            //console.log(criterias)
            payload.transaction_Ref = transaction_Ref;
            containerSearch(2);
            containerSearch(1);
        }

        if (e && e.action === 'Close') {
            console.log("Close")
        }
        setdialogueOpenView(false);
    }

    const UpdatePayload = () => {
        if (param.DAOpen === "Creator") {
            payload.directoryCode = param?.selectedDetail?.kontactCode;
            payload.kontactCode = param?.selectedDetail?.kontactCode;

            payBuildload.directoryCode = param?.selectedDetail?.kontactCode;
            payBuildload.kontactCode = param?.selectedDetail?.kontactCode;
        }

        if (param.DAOpen === "Imprint") {
            payload.directoryCode = param?.selectedDetail?.companyName;
            payload.companyName = param?.selectedDetail?.companyName;

            payBuildload.directoryCode = param?.selectedDetail?.companyName;
            payBuildload.companyName = param?.selectedDetail?.companyName;
        }

        if (param.DAOpen === "Asset") {
            payload.directoryCode = param?.selectedDetail?.assetCode;
            payload.assetCode = param?.selectedDetail?.assetCode;

            payBuildload.directoryCode = param?.selectedDetail?.assetCode;
            payBuildload.assetCode = param?.selectedDetail?.assetCode;
        }

        if (param.DAOpen === "Account") {
            payload.directoryCode = param?.selectedDetail?.code;
            payload.SubProvider = param?.selectedDetail?.code;

            payBuildload.directoryCode = param?.selectedDetail?.code;
            payBuildload.SubProvider = param?.selectedDetail?.code;
        }
    }

    const containerSearch = (level: any) => {
        console.log(activeAllTime)
        if (!activeAllTime) { payload.activeAllTime = 0 }
        if (activeAllTime) { payload.activeAllTime = 1 }
        UpdatePayload();
        payload.type = activePerformanceTab;
        payload.level = level;
        CommonUtilities.BtnLoading("containerSearch");

        payload.periodFrom = reportingFrom && reportingFrom.length > 0 ? reportingFrom : String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom));
        payload.periodTo = reportingTo && reportingTo.length > 0 ? reportingTo : String(Filter.DateTimeFormatNumber(periodSelected?.periodTo));
        //totalRows = 0;
        //setTotalRows(totalRows);

        let cacheFound = null
        console.log(level)
        if (level === 2) {
            payload.level = 2;
            cachingMechanisum.readFromStoredCacheKey(payload, 'AnalyticListing').then((res: any) => {
                cacheFound = res;
                console.log(cacheFound);

                if (res) {
                    dataAssignment(res, level);
                    CommonUtilities.blockUiLoading(false);
                }

                if (!res) {
                    payload.level = 2;
                    ContainerServices.financialPerformancesearch(payload).then((res: any) => {
                        dataAssignment(res, level);
                        cachingMechanisum.analyticCacheBuild(payload, res, "AnalyticListing");
                    });
                }
            });
        } else {
            ContainerServices.financialPerformancesearch(payload).then((values) => {

                dataAssignment(values, level);
                //console.log( CommonUtilities.relativeDataRemapping(values.data, values.headers.original))
                if (values) { CommonUtilities.RemoveBtnLoading("containerSearch"); }
            })
        }

        var newpayload = { ...payload, criteriaList: criterias }
        param?.onChangeSummary(newpayload);
    }

    const dataAssignment = (values: any, level: any) => {

        if (level === 2) {
            setTotalRows(values?.totalRows ? values.totalRows : 0)
            execHeader = [];
            Object.entries(values.headers.original).forEach(([key, value]) => {
                var name = value?.toString().replace(/\s+/g, '')
                execHeader.push(name)
            });
            setexecHeader(execHeader)

            headerMaping = [];
            Object.entries(values.headers.original).forEach(([key, value]) => {
                headerMaping.push(value)
            });
            setHeaderMaping(headerMaping)

            headerType = [];
            Object.entries(values.headers.fieldType).forEach(([key, value]) => {
                headerType.push(value)
            });
            setHeaderType(headerType)

            console.log(headerType)
            setfinancialPerformanceList(CommonUtilities.relativeDataRemapping(values.data, values.headers.original));
        }

        if (level === 1) {
            projectAnalysisSummary = CommonUtilities.relativeDataRemapping(values.data, values.headers.original)
            setprojectAnalysisSummary(projectAnalysisSummary)
        }
    }

    const onChangeSummary = (e: any) => {

    }
    const containerExport = () => {
        if (!activeAllTime) { payload.activeAllTime = 0 }
        if (activeAllTime) { payload.activeAllTime = 1 }
        UpdatePayload();
        payload.type = activePerformanceTab;
        CommonUtilities.BtnLoading("containerExport");
        payload = { ...payload, ...{ exportType: "exportType", export: 1 } }
        console.log(payload)
        directoryServices.excelGenericExport(payload).then((values: any) => {
            console.log(values)
            CommonUtilities.RemoveBtnLoading("containerExport");
        })

    }

    const containerExportDetail = () => {
        if (!activeAllTime) { payload.activeAllTime = 0 }
        if (activeAllTime) { payload.activeAllTime = 1 }
        UpdatePayload();
        payload.type = "FinancialDetail";
        CommonUtilities.BtnLoading("containerExport");
        payload = { ...payload, ...{ exportType: "exportType", export: 1 } }
        console.log(payload)
        directoryServices.excelGenericExport(payload).then((values: any) => {
            console.log(values)
            CommonUtilities.RemoveBtnLoading("containerExport");
        })

    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)
    }

    const periodValidation = () => {

        console.log(payload);

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");

        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }

        if (payload.periodFrom.length !== 8) {

            setreportingFrom(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)));
        }

        if (payload.periodTo.length !== 8) {

            setreportingTo(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)));
        }

    }

    const onChange = (period: any) => {

        if (period.periodFrom) {
            payload.periodFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            reportingFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            setreportingFrom(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
        }

        if (period.periodTo) {
            payload.periodTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            reportingTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            setreportingTo(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
        }

        periodValidation();
        if (period && period.action && period.action === 2) {
            containerSearch(2);
            containerSearch(1);
        }
    }

    const tabChange = (e: any) => {
        payload.type = e;
        activePerformanceTab = e;
        setactivePerformanceTab(activePerformanceTab);
        totalRows = 0;
        setTotalRows(totalRows)
        //containerSearch(2);
        //containerSearch(1);
    }

    const BuildWorkSpace = () => {

        CommonUtilities.BtnLoading("WorkSpaceCall");
        directoryServices.financialPerformance(payBuildload).then((value: any) => {
            if (value) { CommonUtilities.RemoveBtnLoading("WorkSpaceCall"); }
        })
    }

    const PaginationList = (e: any) => {
        payload.pageNumber = e.pageNumber;
        payload.pageSize = e.pageSize;
        payload.type = activePerformanceTab;
        containerSearch(2);
    }

    const removeTag = (tag: any) => {
        console.log(tag)
        if (tag && tag.transContainersId) {
            ContainerServices.UnlinkContainer(tag.transContainersId).then((values) => {

                containerSearch(2);
                containerSearch(1);
            })

            console.log(criterias.filter((value: any) => value.containerCode !== tag.containerCode))

            setCriterias(criterias.filter((value: any) => value.containerCode !== tag.containerCode))


            cachingMechanisum.analyticCacheBuildDel(payload, "AnalyticListing");
        }
    }

    const allTimeBtn = (allTime: any) => {

        if (allTime !== allTime) {
            cachingMechanisum.analyticCacheBuildDel(payload, "AnalyticListing");
        }

        activeAllTime = !allTime;
        setactiveAllTime(activeAllTime);
        containerSearch(2);
        containerSearch(1);
    }

    const checkBox = (index: any) => {

        console.log(index)
        console.log(globalSearchList[index])

        const updatedList = globalSearchList.map((item: any, i: any) =>
            i === index ? { ...item, isActive: !item.isActive } : item
        );
        setglobalSearchList(updatedList);
        /*if (globalSearchList[e]) {
            globalSearchList[e].isActive = !globalSearchList[e]?.isActive
            setglobalSearchList(globalSearchList)
        }*/
        //console.log(globalSearchList)
        console.log(globalSearchList[index])

        saveSearchFilter();
    }

    useEffect(() => {
        setglobalSearchList(globalSearchList)
    }, [globalSearchList])

    const saveSearchFilter = () => {

        if (activePerformanceTab === "Financial") {
            globalType = 'ContractRoyaltyDetail'
        }

        if (activePerformanceTab === "Performance") {
            globalType = 'ContractAuditDetail'
        }

        var dataArray = [];
        for (var i = 0; i < globalSearchList.length; i++) {
            if (globalSearchList[i]?.isActive) {
                dataArray.push(globalSearchList[i])
            }
        }
        console.log(dataArray);

        directoryServices.SaveGlobalSearchList(globalType, dataArray).then((data) => {

            directoryServices.globalSearchList(globalType).then((data) => {
                globalSearchList = data;
                setglobalSearchList(globalSearchList)
            })
        })
    }


    return (<>
        <div className="ws-12">

            <div className="pull-left mrxl p0">
                <a className={activePerformanceTab === 'Performance' ? 'icon-btn edit active' : 'icon-btn edit'} onClick={() => { setactivePerformanceTab('Performance'); tabChange("Performance") }}>Performance</a>
                <a className={activePerformanceTab === 'Financial' ? 'icon-btn edit active' : 'icon-btn edit'} onClick={() => { setactivePerformanceTab('Financial'); tabChange("Financial") }}>Royalties</a>
            </div>

            <div className="pull-left mrxl">
                <div className="centerWindow ws-12">
                    <a className="icon-btn edit btn-xl" onClick={() => setperiodSelection(true)}>
                        <i className="icon-angle-right text-m pull-right mll"></i>
                        <span className="pull-right success"> {Filter.NumToDate(reportingTo)}</span>
                        <i className="icon-vertical-line ml pull-right mr text-sl success"></i>
                        <span className="pull-right success">{Filter.NumToDate(reportingFrom)}</span>
                    </a>
                </div>

            </div>

            <div className="pull-left mt mr">
                <span className="pull-left mr"> All Time </span>
                <label className="switch">
                    <input type="checkbox" onChange={() => { allTimeBtn(activeAllTime) }} />
                    {activeAllTime && <span className="slider round text-left white pm pts">Yes</span>}
                    {!activeAllTime && <span className="slider round text-right white pm pts sliderOff">No</span>}
                </label>
            </div>

            <div className="pull-left mrxl hide">
                <a className={hideGraph ? "btn-info bg-level7 btn-xl" : "btn-info btn-xl "} onClick={() => sethideGraph(true)}> <i className="icon-price-list" />  </a>
                <a className={!hideGraph ? "btn-info bg-level7 btn-xl" : "btn-info btn-xl "} onClick={() => sethideGraph(false)}> <i className="icon-graph" />  </a>
            </div>

            <div className="pull-right">

                <button className="btn-warning buttonLoad hide" id="WorkSpaceCall" onClick={() => BuildWorkSpace()}> Build WorkSpace </button>
                <button className="icon-btn edit buttonLoad hide" id="containerExport" onClick={containerExport}> Export  </button>

                <div className=" hover-box pull-right pull-left mb">

                    <ul className="hover-block textboxDropdownList box rightReset text-right borderRoundedMedium borderRoundedMedium">

                        {
                            globalSearchList?.map((valus: any, index: any) => {
                                return (

                                    <li className="hover-box text-left ws-5 pb">
                                        <input type="checkbox" onChange={() => checkBox(index)} checked={valus?.isActive} value={valus?.isActive} />
                                        {valus?.displayName}
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <button className="icon-btn info">
                        <i className="icon-LPurple-Setting m0 p0"></i>
                    </button>
                </div>

                <div className="hover-box pull-right">

                    <a className="icon-btn edit ws-12 m0 text-center" onClick={containerExport}>Export</a>

                    {activePerformanceTab === 'Financial' && <div className="hover-block">
                        <a className="hover-box icon-btn edit pull-left full-width" onClick={containerExportDetail}>Detail Export</a>
                    </div>}

                </div>


                <button className="icon-btn edit buttonLoad" id="containerSearch" onClick={() => { containerSearch(2); containerSearch(1); }}> Search  </button>
                <button className="btn-queue" onClick={() => setdialogueOpenView(true)}>Filter </button>
            </div>

            <div className="ws-12 ptl">
                {(transaction_Ref.length > 0) && <div className="ws-12 ptl mtl">
                    <span className="text-bold pull-left mt hide">Container Code : </span>
                    {
                        containerType?.map((value: any) => {

                            if ((criterias.filter((valueStored: any) => valueStored.containerType === value)).length > 0) {

                                return (

                                    <div>
                                        <span className="text-bold pull-left mt ">{value} </span>

                                        {(() => {
                                            return (
                                                criterias?.map((values: any, index: any) => {

                                                    if (values.containerType === value) {
                                                        return (
                                                            <a className="btn ms ps pull-left" style={{ background: CommonUtilities.myArray[index], color: "RGB(255,255,255)" }}>
                                                                <span className="mrs mb white" >{values.containerCode}</span>

                                                                <span className="pull-right mtss white" onClick={() => removeTag(values)}>
                                                                    <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                                </span>
                                                            </a>
                                                        )
                                                    }

                                                })
                                            )

                                        })()}

                                    </div>
                                )
                            }

                        })
                    }
                </div>}

                {(totalRows > 0) && <>
                    <h2 className="pull-left capitalize  m0"> Search results: {totalRows} </h2>

                    <div className="verticalMediumWide hover-box text-center pull-right hide">
                        <ul className="hover-block textboxDropdownList box pLarge rightReset">
                            {
                                globalSearchList.map((values: any, index: any) => {

                                    return (

                                        <li className="hover-box text-left ws-6 pb" >
                                            <input type="checkbox" defaultChecked={values.isActive} value={values.isActive} onClick={() => checkBox(index)} />  {values.filterName}
                                        </li>
                                    )
                                })
                            }
                            <li className="hover-box">
                                <button className="icon-btn edit btn-sm pull-left mt" onClick={saveSearchFilter}> Save Criterias</button>
                            </li>
                        </ul>
                        <button className="btn-l">
                            <i className="icon-settings m0 p0 text-l"></i>
                        </button>
                    </div>
                </>}

                {(totalRows === 0) && <div className="ws-12 mtl prxl pbl">
                    <span className="alert alert-success ws-12 text-center">No data Available</span>
                </div>}

                {(totalRows > 0) && <>

                    {(hideGraph) && <><table className="bgWhite table tablePresentation">
                        <thead>
                            <tr className="forceSingleLine">
                                {headerMaping.map((headerName: any) => {
                                    return (<th>{CommonUtilities.headerName(headerName)}</th>)
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {financialPerformanceList.map((listing: any) => {
                                return (
                                    <tr>
                                        {execHeader.map((headerName: any, index: any) => {

                                            if (headerType[index] === "Number") {
                                                return (<td className="text-right">{listing[headerName] && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(listing[headerName])}</td>)
                                            }

                                            if (headerType[index] === "Text") {
                                                return (<td>{listing[headerName]}</td>)
                                            }
                                        })}
                                    </tr>
                                )
                            })}
                            <tr>

                            </tr>
                            <td colSpan={headerMaping?.length - (activePerformanceTab === 'Performance' ? 1 : 2)} className="success text-bold text-right"> Total</td>
                            <td className="text-right"> {CommonUtilities.getCSymbols(clientDetailList?.homeCurrency)} {projectAnalysisSummary[0]?.totalRev && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(projectAnalysisSummary[0]?.totalRev)} </td>
                            {activePerformanceTab === 'Performance' && false && <td className="text-right hide"> {CommonUtilities.getCSymbols(clientDetailList?.homeCurrency)} {projectAnalysisSummary[0]?.totalRoy && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(projectAnalysisSummary[0]?.totalRoy)} </td>}
                            {activePerformanceTab === 'Financial' && <td className="text-right"> {CommonUtilities.getCSymbols(clientDetailList?.homeCurrency)} {projectAnalysisSummary[0]?.totalExp && new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(projectAnalysisSummary[0]?.totalExp)} </td>}
                        </tbody>
                    </table>

                        {(() => {
                            if (totalRows > 10) {
                                return <div className="ws-12 ptl mbl pbl"><Pagination onChange={PaginationList} totalRows={totalRows} /></div>
                            }
                        })()}
                    </>}

                </>}
            </div>
        </div>

        {(() => {
            if (periodSelection === true) {
                return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={Filter.convertToDateString(reportingFrom)} periodTo={Filter.convertToDateString(reportingTo)} />;
            }
            if (dialogueOpenView) {
                return (<ContainerSlider onChangeClose={onChangeClose} open={dialogueOpenView} selectedDetail={param.selectedDetail} type={param?.DAOpen} />)
            }

        })()}
    </>)
}